import { render, staticRenderFns } from "./ImportBrandDialog.vue?vue&type=template&id=05f868d8&scoped=true"
import script from "./ImportBrandDialog.vue?vue&type=script&lang=js"
export * from "./ImportBrandDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportBrandDialog.vue?vue&type=style&index=0&id=05f868d8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f868d8",
  null
  
)

export default component.exports